import { WorkspaceDetailsDto } from "@common/dto/workspace/workspace-details.dto";
import { useQuery } from "@tanstack/react-query";
import { UnwrapOpaque } from "@ts-rest/core";
import { workspacesContract } from "../common/contracts/workspaces.contract";
import { getBackendAPIClient } from "../lib/backendAPIClient";

type WorkspaceQueryParams = UnwrapOpaque<
    typeof workspacesContract.getWorkspaces.query
>;

const workspaceQueryKeys = {
    all: () => ["workspace"],
    workspaces: (params?: WorkspaceQueryParams) => [
        ...workspaceQueryKeys.all(),
        "workspaces",
        params,
    ],
} as const;

const workspaceContractClient = getBackendAPIClient(workspacesContract);

export function useWorkspaces(params?: WorkspaceQueryParams) {
    return useQuery({
        queryKey: workspaceQueryKeys.workspaces(params),
        queryFn: async () => {
            const response = await workspaceContractClient.getWorkspaces({
                query: params ?? {},
            });

            return {
                ...response.body,
                data: response.body.data.map(WorkspaceDetailsDto.deserialize),
            };
        },
    });
}
